import { styled } from "@mui/material/styles";
import { Stack, useTheme, useMediaQuery, Typography } from "@mui/material";
import { useShow } from "hooks/useShow";
import Grid from "@mui/material/Unstable_Grid2";
import { NavLink } from "react-router-dom";
import Transitions from "components/Transitions";

const BackedByBox = styled(Stack)``;

const Head = styled(Typography)`
  color: #fff;
  font-size: 46px;
  font-weight: 500;
  max-width: 450px;
  margin-top: 30px;
  line-height: 1.2;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
      marginTop: "10px",
      maxWidth: "100%",
    },
  })};
`;

const SubHead = styled(Typography)`
  color: #999;
  font-size: 18px;
  margin-top: 5px;
  font-family: KindSansRegular;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
    },
  })};
`;

const Containter = styled(Stack)`
  height: 100%;
  width: 1200px;
  padding: 15px 25px 200px;
  box-sizing: border-box;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "0px 20px 60px",
    },
  })};
`;

const ConBox = styled(Stack)`
  border-radius: 20px;
  border: 1px solid #3f3f3f;
  background: #191919;
  padding: 40px 30px;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
      padding: "30px 20px",
    },
  })};
`;

const Desc = styled(Typography)`
  color: #999;
  font-size: 16px;
  font-family: KindSansRegular;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSzie: "12px",
    },
  })};
`;

const ConBtn = styled(NavLink)`
  border-radius: 88px;
  border: 1px solid #2f2f2f;
  padding: 11px 0;
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin-top: 104px;
  display: inline-block;
  max-width: 146px;
  &:hover {
    color: #000;
    background: #fff;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSzie: "14px",
      marginTop: "30px",
    },
  })};
`;

const Contact = () => {
  const theme = useTheme();
  const downToMd = useMediaQuery(theme.breakpoints.down("md"));
  const { ref, isShow } = useShow();

  return (
    <BackedByBox justifyContent="center" alignItems="center" direction="row">
      <Containter>
        <Grid
          justifyContent={downToMd ? "center" : "space-between"}
          alignItems={downToMd ? "center" : "flex-start"}
          direction={downToMd ? "column" : "row"}
          container
          spacing={10}
          ref={ref}
        >
          <Grid xs={12} md={6}>
            <Stack>
              <Transitions delay={200} isShow={isShow}>
                <SubHead>Contact Us</SubHead>
              </Transitions>
              <Transitions delay={400} isShow={isShow}>
                <Head>Join our network of top partners and providers.</Head>
              </Transitions>
            </Stack>
          </Grid>
          <Grid xs={12} md={6}>
            <Transitions delay={400} isShow={isShow}>
              <ConBox>
                <Desc>
                  We're always improving the client experience, growing
                  liquidity, providing more options, and building our
                  one-of-a-kind community one brick at a time. If you provide a
                  first-class digital assets service that incorporates our
                  products we want to hear from you!
                </Desc>
                <Desc mt={30}>
                  By submitting, you agree to receive updates, insights and news
                  from us. This site is protected by the Google Privacy Policy
                  and Terms of Service apply.
                </Desc>
                <ConBtn
                  to={
                    "https://docs.google.com/forms/d/e/1FAIpQLSe8xn_F3Pu8QpEsgB7yk5Zyl5JuDeFuFUdW3oNWX3qoV_Uh6w/viewform?usp=header"
                  }
                  target={"_blank"}
                >
                  Submit
                </ConBtn>
              </ConBox>
            </Transitions>
          </Grid>
        </Grid>
      </Containter>
    </BackedByBox>
  );
};

export default Contact;
